module.exports = __webpack_public_path__ + "img/im_dashboard_person_with_chart.cca07900.png";